import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FileNameWithIcon from "../../../../components/fileNameWithIcon";
import useProfileHelper from "pages/profile/useProfileHelper";
import { handledUserFileTypes } from "utils/constantValues";

function formatFileTypeLabel(type = "") {
  return String(type)
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[\-_]+/g, " ")
    .trim();
}

function OtherFilesSection() {
  const [t] = useTranslation();
  const { downloadFileInANewTab } = useProfileHelper();
  const userDetails = useSelector((state) => state.userDetails || {});

  const filesByType = (userDetails?.userFiles || []).reduce((groups, file) => {
    if (!file?.id || handledUserFileTypes.includes(file.type)) {
      return groups;
    }

    const typeKey = file.type || "otherDocuments";
    if (!groups[typeKey]) {
      groups[typeKey] = [];
    }
    groups[typeKey].push(file);
    return groups;
  }, {});

  const fileTypeGroups = Object.entries(filesByType);

  if (fileTypeGroups.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col items-start gap-3 self-stretch w-[1156px] h-px bg-[#E4E4E7] w-full"></div>
      <div
        id="otherFilesSection"
        className="flex p-[24px] gap-[24px] self-stretch flex-wrap"
      >
        {fileTypeGroups.map(([type, files]) => {
          const formattedLabel = formatFileTypeLabel(type);
          const title =
            t(type, { defaultValue: formattedLabel }) ||
            t("otherDocuments") ||
            formattedLabel;

          return (
            <div key={type} className="flex items-start gap-6 self-stretch">
              <div className="flex flex-col items-start w-[330px] gap-3">
                <div className="flex items-center gap-2">
                  <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
                    {title}
                  </span>
                </div>
                <div className="flex flex-col flex-wrap">
                  {files.map((file, index) => (
                    <FileNameWithIcon
                      key={file.id}
                      fileName={file.name}
                      showHover={true}
                      withDelete={false}
                      onDownloadHandler={() => downloadFileInANewTab(file.id)}
                      withoutBorder={files.length === index + 1}
                    />
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default OtherFilesSection;
